import withOauthRouteHandling from '../../../decorators/auth/withOauthRouteHandling';
import {
  DATA_REQUEST_AUTH_PATH,
  DATA_REQUEST_CONFIRM_PATH,
} from '../../../constants/paths';
import DataRequestAuthLoader from './DataRequestAuthLoader';

export default withOauthRouteHandling(
  DataRequestAuthLoader,
  DATA_REQUEST_AUTH_PATH,
  DATA_REQUEST_CONFIRM_PATH,
);
